import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { FormDrawer } from './FormDrawer';

const EMPTY_LINE = () => ({
  delivery_id: 0,
  sale_id: '',
  dispatch_guide: '',
  shipment_scope: 'Completo',
  tracking_code: '',
  stop_order: 0,
});

const SHIPMENT_SCOPE_OPTIONS = [
  { value: 'Completo', label: 'Completo' },
  { value: 'Parcial', label: 'Parcial' },
];

export const LogisticsTripForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  isEditing = false,
  formData,
  onChange,
  formError = '',
  saleOptions = [],
  providerOptions = [
    { value: '01', label: '01 · LYB' },
    { value: '02', label: '02 · Fedex' },
    { value: '03', label: '03 · TVP' },
    { value: '00', label: '00 · Interno' },
  ],
  handlerOptions = [{ value: '', label: 'Seleccionar ejecutivo' }],
  zIndex = 10000,
}) => {
  const tripLines = Array.isArray(formData?.trip_lines) ? formData.trip_lines : [];

  const updateLines = (nextLines) => {
    onChange('trip_lines', nextLines);
  };

  const handleAddLine = () => {
    updateLines([...tripLines, EMPTY_LINE()]);
  };

  const handleRemoveLine = (index) => {
    updateLines(tripLines.filter((_, i) => i !== index));
  };

  const handleLineChange = (index, field, value) => {
    const next = tripLines.map((line, i) => {
      if (i !== index) return line;
      const updated = { ...line, [field]: value };
      if (field === 'sale_id') {
        const opt = saleOptions.find((o) => String(o.value) === String(value));
        if (opt) {
          if (!String(updated.dispatch_guide || '').trim() && opt.dispatch_guide) {
            updated.dispatch_guide = opt.dispatch_guide;
          }
          updated.sale_code = opt.sale_code || updated.sale_code || '';
          updated.organization_name = opt.organization_name || updated.organization_name || '';
        }
      }
      return updated;
    });
    updateLines(next);
  };

  const sections = [
    {
      key: 'trip',
      title: 'Viaje',
      columns: 3,
      fields: [
        {
          key: 'trip_code',
          label: 'Correlativo (TRPYY-ZZXXX)',
          disabled: true,
          readOnly: true,
        },
        {
          key: 'started_at',
          label: 'Fecha y hora de viaje',
          type: 'datetime-local',
        },
        {
          key: 'handler_name',
          label: 'Ejecutivo',
          type: 'select',
          options: handlerOptions,
        },
        {
          key: 'provider_code',
          label: 'Proveedor',
          type: 'select',
          options: providerOptions,
        },
        { key: 'carrier_name', label: 'Nombre transportista' },
        { key: 'cost', label: 'Costo viaje', type: 'number' },
        {
          key: 'trip_type',
          label: 'Tipo de viaje',
          type: 'select',
          options: [
            { value: 'Completo', label: 'Completo (bodega → cliente)' },
            { value: 'Primera milla', label: 'Primera milla' },
            { value: 'Milla media', label: 'Milla media' },
            { value: 'Ultima milla', label: 'Última milla' },
            { value: 'Retiro', label: 'Retiro' },
            { value: 'Traslado interno', label: 'Traslado interno' },
            { value: 'Devolucion', label: 'Devolución' },
          ],
        },
        { key: 'origin_location', label: 'Origen' },
        { key: 'destination_location', label: 'Destino' },
        {
          key: 'trip_status',
          label: 'Estado viaje',
          type: 'select',
          options: [
            { value: 'Planificado', label: 'Planificado' },
            { value: 'En Ruta', label: 'En Ruta' },
            { value: 'En Curso', label: 'En Curso' },
            { value: 'Completado', label: 'Completado' },
            { value: 'Finalizado', label: 'Finalizado' },
            { value: 'Incidencia', label: 'Incidencia' },
            { value: 'Cancelado', label: 'Cancelado' },
          ],
        },
        { key: 'notes', label: 'Notas', type: 'textarea', rows: 3, fullWidth: true },
        {
          key: 'trip_lines',
          label: 'Entregas del viaje',
          type: 'custom',
          fullWidth: true,
          render: ({ colors }) => {
            const inputStyle = {
              width: '100%',
              height: '34px',
              boxSizing: 'border-box',
              borderRadius: '8px',
              border: `1px solid ${colors.inputBorder}`,
              backgroundColor: colors.inputBg,
              color: colors.inputText,
              padding: '0 8px',
              fontSize: '12px',
              outline: 'none',
            };
            const headerStyle = {
              color: colors.muted,
              fontSize: '11px',
              fontWeight: 600,
              lineHeight: 1.2,
            };
            const usedSaleIds = new Set(
              tripLines
                .map((line) => String(line.sale_id || ''))
                .filter((id) => id && id !== '0')
            );

            return (
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}
                >
                  <div style={{ fontSize: '12px', color: colors.text, fontWeight: 600 }}>
                    Entregas ({tripLines.length})
                  </div>
                  <button
                    type="button"
                    onClick={handleAddLine}
                    style={{
                      height: '32px',
                      borderRadius: '8px',
                      border: `1px solid ${colors.inputBorder}`,
                      background: 'transparent',
                      color: colors.text,
                      cursor: 'pointer',
                      padding: '0 10px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '12px',
                    }}
                  >
                    <Plus size={14} /> Agregar entrega
                  </button>
                </div>

                {tripLines.length === 0 ? (
                  <div
                    style={{
                      border: `1px dashed ${colors.inputBorder}`,
                      borderRadius: '8px',
                      padding: '16px',
                      textAlign: 'center',
                      color: colors.muted,
                      fontSize: '12px',
                    }}
                  >
                    Sin entregas. Agrega el pedido enviado en este viaje.
                  </div>
                ) : (
                  <div style={{ overflowX: 'auto' }}>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'minmax(220px, 2.2fr) minmax(140px, 1.2fr) 120px 72px',
                        gap: '8px',
                        alignItems: 'center',
                        marginBottom: '6px',
                        minWidth: '560px',
                      }}
                    >
                      {['Pedido / venta', 'Guía de despacho', 'Alcance', ''].map((label) => (
                        <span key={label || 'actions'} style={headerStyle}>
                          {label}
                        </span>
                      ))}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '560px' }}>
                      {tripLines.map((line, index) => {
                        const saleId = String(line.sale_id || '');
                        const optionsForRow = saleOptions.filter((opt) => {
                          const id = String(opt.value);
                          return id === saleId || !usedSaleIds.has(id);
                        });
                        return (
                          <div
                            key={line.delivery_id || `new-${index}`}
                            style={{
                              display: 'grid',
                              gridTemplateColumns: 'minmax(220px, 2.2fr) minmax(140px, 1.2fr) 120px 72px',
                              gap: '8px',
                              alignItems: 'center',
                            }}
                          >
                            <select
                              style={inputStyle}
                              value={saleId}
                              onChange={(e) => handleLineChange(index, 'sale_id', e.target.value)}
                            >
                              <option value="">Seleccionar pedido</option>
                              {optionsForRow.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>
                            <input
                              style={inputStyle}
                              value={line.dispatch_guide || ''}
                              onChange={(e) => handleLineChange(index, 'dispatch_guide', e.target.value)}
                              placeholder="Nº guía"
                            />
                            <select
                              style={inputStyle}
                              value={line.shipment_scope || 'Completo'}
                              onChange={(e) => handleLineChange(index, 'shipment_scope', e.target.value)}
                            >
                              {SHIPMENT_SCOPE_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>
                            <button
                              type="button"
                              onClick={() => handleRemoveLine(index)}
                              title="Quitar entrega"
                              style={{
                                height: '34px',
                                width: '34px',
                                borderRadius: '8px',
                                border: `1px solid ${colors.inputBorder}`,
                                background: 'transparent',
                                color: colors.danger,
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                justifySelf: 'start',
                              }}
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          },
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title={isEditing ? 'Editar viaje' : 'Agregar viaje'}
      subtitle="Viaje del transportista y entregas asociadas"
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={780}
      zIndex={zIndex}
    />
  );
};

export default LogisticsTripForm;
